module.exports = __webpack_public_path__ + "static/media/shinybg.c4959be2.jpg";